<template>
  <div class="pro_main_w d_flex flex_direction_col">
    <!-- 状态 -->
    <!-- <div :class="`pro-state ${stateColor(itemDetail.state)}`">
      {{stateDesc}}
    </div> -->

    <div class="detail_main_info d_flex justify_content_sb flex_direction_col">
      <!-- block-1 -->
      <div
        :class="
          itemDetail.auctionBidUser && showBidBtn
            ? 'main_block_1'
            : 'main_block_11'
        "
      >
        <!-- 时间文本 -->
        <p class="c_1A1A1A">
          <span class="state_time_desc cell_label fz12"
            >{{ spaceDes(itemDetail.state) }}：</span
          >
          <span class="font_w_bold fz14" v-if="isShowCountDown">
            <span v-if="d" class="time_i">
              <em class="time_num fz24 font_w_bold">{{ d }}</em
              >天</span
            ><span class="time_i">
              <em class="time_num fz24 font_w_bold">{{ h }}</em
              >时</span
            ><span class="time_i"
              ><em class="time_num fz24 font_w_bold">{{ m }}</em
              >分</span
            ><span>
              <em class="time_num fz24 font_w_bold">{{ s }}</em
              >秒</span
            >
          </span>
          <!-- 如果socket没返回结束时间，则取竞拍结束时间 -->
          <span v-else class="font_w_bold">{{ itemDetail.stateEndTime }}</span>
          <span
            v-if="itemDetail.state == 4"
            style="font-size: 13px; color: #808080"
            >（{{ auctionTime(itemDetail.auctionStartTime) }}开拍）</span
          >
        </p>
        <!-- 项目展示价格（成交价，当前价） -->
        <div class="price_w">
          <div class="cell_row d_flex">
            <span class="cell_label fz12 c_1A1A1A">{{
              priceDesc(itemDetail.state)
            }}</span>
            <span class="fz12 c_CF3342">
              <el-tooltip
                effect="dark"
                :content="amountTran(itemDetail.currentPrice)"
                placement="top"
              >
                <em class="fz24 font_w_bold" style="margin: 0 5px">{{
                  formatMoney(itemDetail.currentPrice)
                }}</em>
              </el-tooltip>
            </span>
            <span class="fz12 c_CF3342">{{ itemDetail.priceUnitDesc }}</span>
            <!-- <span  v-if="itemDetail.priceUnit == 'zongjia'" class="fz12 c_CF3342">（总价）</span> -->
          </div>
        </div>
        <!-- 延时次数 -->
        <div class="delay-count" v-if="itemDetail.statis.delayCnt > 0">
          延时{{ itemDetail.statis.delayCnt }}次
        </div>
      </div>
      <!-- block-2 -->
      <div
        v-if="isEnd"
        class="main_block_2 x_y_center flex_direction_col bc_e6e6e6"
      >
        <!-- 不同竞拍状态备注 -->
        <div class="state_end_desc d_flex align_item_c">
          <img :src="require(`@/assets/images/auction_1.png`)" alt="" />

          <span class="fz16 c_1A1A1A font_w_bold" v-if="itemDetail.remark">{{
            itemDetail.remark
          }}</span>
        </div>
        <!-- 已成交-的公告按钮 -->
        <div
          class="d_inline_flex fz12"
          v-if="itemDetail.state === 9 && cmsNoticeNode"
        >
          <el-button
            class="notice_btn cursor_pointer c_fff bc_0983CC"
            :disabled="!checkNoticeIdKeys.makeId"
            @click="goCmsNode(cnoticeNode, checkNoticeIdKeys.makeId)"
            >查看结果公示</el-button
          >
        </div>
        <!-- 通知公告按钮 -->
        <div
          v-if="
            itemDetail.state === 8 && itemDetail.state !== 7 && cmsNoticeNode
          "
        >
          <el-button
            class="notice_btn cursor_pointer c_fff bc_0983CC"
            :disabled="!checkNoticeIdKeys.informId"
            @click="goCmsNode(tnoticeNode, checkNoticeIdKeys.informId)"
            >查看通知公示</el-button
          >
        </div>
      </div>
      <!-- block-2 -->
      <div
        v-else
        :class="
          showRemindLogin || (!showBidBtn && !showRemindLogin)
            ? 'main_block_2222 flex_direction_col bc_e6e6e6'
            : 'main_block_222 flex_direction_col bc_e6e6e6'
        "
      >
        <div
          class="d_flex"
          :style="
            itemDetail.auctionBidUser && showBidBtn
              ? 'margin-top: 15px'
              : 'margin-top: 15px'
          "
        >
          <div class="oo"></div>
          <div
            :class="
              !BidFlag
                ? 'bid_text fz12 c_1A1A1A location'
                : 'bid_text fz12 c_1A1A1A '
            "
            :style="noShowRemindLogin ? 'position:relative;top:18px' : ''"
          >
            出&nbsp;&nbsp;&nbsp;价
          </div>
          <div
            :class="!BidFlag ? 'location' : ''"
            :style="noShowRemindLogin ? 'position:relative;top:18px' : ''"
          >
            <el-form
              :model="publicForm"
              ref="publicForm"
              label-width="0"
              :rules="rules"
              @validate="onValidatePublicForm"
              @submit.native.prevent
            >
              <!-- @submit.native.prevent作用：当表单只有一个输入框时，阻止默认按回车键提交表单 -->
              <el-form-item prop="floorPrice">
                <div class="d_flex">
                  <el-input
                    class="price_input"
                    v-model="inputPrice"
                    :disabled="disBidMoney(itemDetail.state)"
                    @input="onTofixedInput($event, publicForm, 'floorPrice')"
                    @keyup.enter.native="onAutionBidClick"
                    maxlength="16"
                  ></el-input>
                  <!-- 出价幅度按钮 -->
                  <div
                    class="range_w d_flex flex_direction_col justify_content_sa"
                    v-if="showBidMoneyRange"
                  >
                    <div
                      @click="onAddAuctionRange"
                      class="add_range c_fff"
                    ></div>
                    <!-- :class="
                        disBidMoney(itemDetail.state) ? 'cursor_no_drop' : !isPositive ? itemDetail.biddings[0] ? convertPriceToInt(inputPrice) === itemDetail.biddings[0].bidPrice ? 'cursor_no_drop' : '' : 'cursor_no_drop' : ''
                      " -->
                    <div
                      @click="onReduceAuctionRange"
                      class="Reduce_range c_fff"
                    ></div>
                    <!-- :class="
                        disBidMoney(itemDetail.state) ? 'cursor_no_drop' : isPositive ? itemDetail.biddings[0] ? convertPriceToInt(inputPrice) === itemDetail.biddings[0].bidPrice ? 'cursor_no_drop' : '' : 'cursor_no_drop' : ''
                      " -->
                  </div>
                </div>
              </el-form-item>
            </el-form>

            <!-- 缴纳保证金报名；出价 -->

            <!-- 预告中，报名中 -->
            <div
              v-if="isShowMriginApply"
              class="d_flex align_item_c location_top"
              style="margin-top: 18px"
            >
              <div
                class="pay_margin fz12 text_center c_fff"
                :class="
                  itemDetail.margin && !isAdvancing ? 'allow_buy' : 'bc_ccc'
                "
                @click="onMriginApplyClick"
              >
                <template v-if="isDeposit">
                  <div>立即报名</div>
                  <div class="" style="margin-left: 3px; margin-top: 3px">
                    交易保证金￥{{ formatMoney(itemDetail.margin) || 0 }}&nbsp;
                  </div>
                </template>
                <template v-else>
                  <span>立即报名</span>
                </template>
              </div>
            </div>

            <!-- 竞价中-出价 -->
            <div v-if="showBidBlock" :class="isState5 ? 'state5' : ''">
              <el-button
                v-if="showBidBtn"
                class="bid_btn bc_0983CC"
                :disabled="
                  !itemDetail.isApply ||
                  !allowBidMoney ||
                  disBidMoney(itemDetail.state)
                "
                :style="
                  showNotApplyText ? 'position: relative;top: -29px;' : ''
                "
                @click="onAutionBidClick"
                >出价</el-button
              >
              <div
                class="cannot_bid_tip text_center c999 fz12"
                v-if="showNotApplyText"
              >
                您未报名该项目，无法参与出价！
              </div>
            </div>

            <!-- 提醒登录 -->
            <div
              v-if="showRemindLogin && !noShowRemindLogin"
              :class="
                showRemindLogin && showBidBlock ? 'paid_login01' : 'paid_login'
              "
              :style="
                isState5
                  ? 'position: relative;top: -23px'
                  : !BidFlag
                  ? 'position: relative;top: -7px'
                  : 'position: relative;top: -16px'
              "
            >
              <div class="x_y_center fz12 letter_spacing_1">
                <img
                  src="@/assets/images/tip_icon.png"
                  alt=""
                  style="margin-right: 2px"
                />
                提醒：先报名再出价。如您已报名,<span
                  @click="onLoginClick"
                  class="login_btn cursor_pointer fz12"
                  >请登录</span
                >
              </div>
            </div>
            <div
              v-if="!showBidBtn && !showRemindLogin && !noShowRemindLogin"
              class="paid_login02 x_y_center fz12 letter_spacing_1"
              :style="!BidFlag ? 'position: relative;top: -7px' : ''"
            >
              <img
                src="@/assets/images/tip_icon.png"
                alt=""
                style="margin-right: 2px"
              />
              提醒：您还没有报名，报名成功后才能出价。
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="itemDetail.auctionBidUser && showBidRemindBtn"
        class="paid_login03 x_y_center fz12 letter_spacing_1"
      >
        因电脑、网络、浏览器等原因，倒计时可能存在时间差，请尽早出价。
      </div>
      <div v-if="itemDetail.auctionBidUser && showBidBtn" class="container">
        <div
          class="fz14"
          style="width: 50%; position: relative; left: 10px; text-align: center"
        >
          竞投号：{{ itemDetail.auctionBidUser.auctionNo
          }}<img
            v-if="itemDetail.isPriority"
            src="@/assets/images/you.png"
            style="
              height: 16px;
              position: relative;
              top: 2px;
              right: -6px;
              margin-right: 5px;
              background-color: white;
              border-radius: 3px;
            "
          />
          <img
            v-if="itemDetail.isPrincipal"
            src="@/assets/images/wei.png"
            style="
              height: 16px;
              position: relative;
              top: 2px;
              right: -6px;
              margin-right: 5px;
              background-color: white;
              border-radius: 3px;
            "
          />
        </div>
        <div style="margin-top: 4px">
          <img src="@/assets/images/line.png" alt="" />
        </div>
        <div
          class="fz14"
          style="width: 50%; position: relative; right: 10px; padding-left: 1px"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="itemDetail.auctionBidUser.username"
            placement="top"
          >
            <div class="text-overflow-example">
              姓 名：{{ itemDetail.auctionBidUser.username }}
            </div>
          </el-tooltip>
        </div>
      </div>
      <div
        v-if="itemDetail.auctionBidUser && showBidBtn "
        style="
          padding: 5px 10px 5px 7px;
          background-color: #fefee4;
          color: rgb(136, 135, 135);
        "
      >
        <div

          class="x_y_center fz12 letter_spacing_1"
        >
          <img
            src="@/assets/images/tip_icon.png"
            alt=""
            style="margin-right: 2px;margin-bottom:16px"
          />
          如果您是优先权人或办过委托，而竞买号没有优或委，请联系：{{ siteInfo.hotline }}

        </div>
      </div>
      <!-- block-3 -->
      <div class="main_block_3 d_flex fz12">
        <span
          :class="
            itemDetail.auctionBidUser ? 'cell_i02 c_808080' : 'cell_i c_808080'
          "
          ><em class="fz15 c_1A1A1A">{{ itemDetail.statis.onlookerCnt }}</em
          >次围观</span
        >
        <span
          :class="
            itemDetail.auctionBidUser ? 'cell_i02 c_808080' : 'cell_i c_808080'
          "
          ><em class="fz15 c_1A1A1A">{{ itemDetail.statis.applyCnt }}</em
          >人报名</span
        >
        <span
          :class="
            itemDetail.auctionBidUser ? 'cell_i02 c_808080' : 'cell_i c_808080'
          "
          ><em class="fz15 c_1A1A1A">{{ itemDetail.biddings.length }}</em
          >次出价</span
        >
      </div>
    </div>
    <!-- block-4 -->
    <div class="main_block_4 fz12 c_808080">
      <div class="cell_row d_flex flex_wrap">
        <div class="" style="flex: 0.33">
          <span>交易保证金：</span>
          <el-tooltip
            effect="dark"
            :content="amountTran(itemDetail.margin)"
            placement="top"
          >
            <span>￥{{ numTranFloat(itemDetail.margin) }}</span>
          </el-tooltip>
        </div>
        <div class="" style="flex: 0.4">
          <span>起拍价：</span>
          <el-tooltip
            effect="dark"
            :content="amountTran(itemDetail.floorPrice)"
            placement="top"
          >
            <span>￥{{ numTranFloat(itemDetail.floorPrice) }}</span>
          </el-tooltip>
        </div>
        <div class="" style="flex: 0.27" v-if="projectInfo.evaluated">
          <span>评估价：</span>
          <el-tooltip
            effect="dark"
            :content="amountTran(projectInfo.evaluated.evaluatePrice)"
            placement="top"
          >
            <span
              >￥{{ numTranFloat(projectInfo.evaluated.evaluatePrice) }}</span
            >
          </el-tooltip>
        </div>
      </div>

      <div class="cell_row d_flex flex_wrap">
        <div class="d_flex" style="flex: 0.33">
          <span>竞价幅度：</span>
          <el-tooltip
            effect="dark"
            :content="amountTran(itemDetail.auctionRange)"
            placement="top"
          >
            <span>￥{{ numTranFloat(itemDetail.auctionRange) }}</span>
          </el-tooltip>
        </div>
        <div class="d_flex" style="flex: 0.33">
          <span class="white_s_nowrap">最大延时次数：</span>
          <span class="white_s_nowrap">{{ itemDetail.delayedCnt }}次</span>
        </div>
        <div class="d_flex" style="flex: 0.33">
          <span class="white_s_nowrap">延时周期：</span>
          <span class="white_s_nowrap"
            >{{ itemDetail.delayedMinute }}分钟/次</span
          >
          <!-- <img src="@/assets/images/tip_icon.png" alt="" /> -->
          &nbsp;
          <el-popover
            placement="top-start"
            title=""
            width="200"
            trigger="hover"
            popper-class="fz12"
          >
            <div slot="">
              <span
                >如果在竞价结束前<em class="fz14 c_000 font_w_bold">{{
                  itemDetail.lastMinute || 0
                }}</em
                >分钟出价，竞价结束时间会在出价时间基础上延长<em
                  class="fz14 c_000 font_w_bold"
                  >{{ itemDetail.delayedMinute || 0 }}</em
                >分钟，最多延时<em class="fz14 c_000 font_w_bold">{{
                  itemDetail.delayedCnt || 0
                }}</em
                >次，超过<em class="fz14 c_000 font_w_bold">{{
                  itemDetail.delayedCnt || 0
                }}</em
                >次后不再延时，直至出价时间结束。</span
              >
            </div>
            <i
              slot="reference"
              class="el-icon-warning-outline fz14 cursor_pointer"
            >
            </i>
          </el-popover>
        </div>
      </div>
    </div>

    <AgreementRead
      v-model="agreementReadModal"
      :content="applyAgreementData.content"
      :title="applyAgreementData.title"
      @onCancal="onCancalAgreement"
      @onConfirm="onConfirmAgreement"
    />
  </div>
</template>

<script>
import { auction_checkNotice, cms_code_article_info } from "@/api/portal";
import { mapGetters, mapActions } from "vuex";
import {
  formatDate,
  tranTimeFormat,
  confirmCallBack,
  numTurnText,
  Ctv,
  uuid,
  amountTran,
  numTranFloat,
  truncateDecimal,
  isEmtry,
} from "@/utils";
import Cookies from "js-cookie";
import { auction_bid, auction_applyed, project_beat_time } from "@/api/action";
import { MySocket } from "@/utils/webSocket";
import { TradeModeText, ModeTrade } from "@/enums";
import Decimal from "decimal.js";
import AgreementRead from "@/components/template/AgreementRead.vue";

export default {
  components: {
    AgreementRead,
  },
  props: {
    itemDetail: {
      type: Object,
      default: () => {},
    },
    reqInfoTime: {
      type: Number,
      default: 0,
    },
  },
  data() {
    // 有效出价数值
    const validNumFloorPrice = (rule, value, callback) => {
      if (value > rule.max) {
        callback(new Error(`${rule.label}不能超过${rule.max}`));
      } else if (value <= 0) {
        callback(new Error(`${rule.label}不能小于或等于0`));
      } else if (
        this.isFirstBid &&
        this.isPositive &&
        !this.itemDetail.isPriority &&
        value < Number(this.itemDetail.currentPrice)
      ) {
        callback(new Error("不能小于或等于当前价"));
      } else if (
        !this.isFirstBid &&
        this.isPositive &&
        !this.itemDetail.isPriority &&
        value <= Number(this.itemDetail.currentPrice)
      ) {
        callback(new Error("不能小于或等于当前价"));
      } else if (
        this.isFirstBid &&
        this.isPositive &&
        this.itemDetail.isPriority &&
        this.itemDetail.biddings[0]?.priority === 1 &&
        value < Number(this.itemDetail.currentPrice)
      ) {
        callback(new Error("已有优先权人出该价格，不能小于或等于当前价"));
      } else if (
        !this.isFirstBid &&
        this.isPositive &&
        this.itemDetail.isPriority &&
        this.itemDetail.biddings[0]?.priority === 1 &&
        value <= Number(this.itemDetail.currentPrice)
      ) {
        callback(new Error("已有优先权人出该价格，不能小于或等于当前价"));
      } else if (
        !this.isFirstBid &&
        this.isPositive &&
        this.itemDetail.isPriority &&
        this.itemDetail.biddings[0]?.priority === 0 &&
        value < Number(this.itemDetail.currentPrice)
      ) {
        callback(new Error("不能小于当前价"));
      } else if (
        this.isFirstBid &&
        this.isReverse &&
        !this.itemDetail.isPriority &&
        value > Number(this.itemDetail.currentPrice)
      ) {
        callback(new Error("不能大于或等于当前价"));
      } else if (
        !this.isFirstBid &&
        this.isReverse &&
        !this.itemDetail.isPriority &&
        value >= Number(this.itemDetail.currentPrice)
      ) {
        callback(new Error("不能大于或等于当前价"));
      } else if (
        this.isFirstBid &&
        this.isReverse &&
        this.itemDetail.isPriority &&
        this.itemDetail.biddings[0]?.priority === 1 &&
        value > Number(this.itemDetail.currentPrice)
      ) {
        callback(new Error("已有优先权人出该价格，不能大于或等于当前价"));
      } else if (
        !this.isFirstBid &&
        this.isReverse &&
        this.itemDetail.isPriority &&
        this.itemDetail.biddings[0]?.priority === 1 &&
        value >= Number(this.itemDetail.currentPrice)
      ) {
        callback(new Error("已有优先权人出该价格，不能大于或等于当前价"));
      } else if (
        !this.isFirstBid &&
        this.isReverse &&
        this.itemDetail.isPriority &&
        this.itemDetail.biddings[0]?.priority === 0 &&
        value > Number(this.itemDetail.currentPrice)
      ) {
        callback(new Error("不能大于当前价"));
      } else if (!this.validMoneyRange) {
        callback(new Error("出价金额必须是竞价幅度的整数倍"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        floorPrice: [
          {
            required: true,
            trigger: "change",
            validator: validNumFloorPrice,
            label: "报价金额",
            max: 1000000000000,
          },
        ],
      },
      diffTime: null,
      countDownTimer: null,
      pollIntervalTimer: null,
      pollInterval: 1000 * 30, //轮询间隔
      checkNoticeIdKeys: {}, //项目包含的公告id
      allowBidMoney: true, //是否允许出价
      allowApply: false, //是否已报名（未知是否审批通过）
      publicForm: {},
      userWs: null, //
      applyWsRes: null, //
      inputPrice: 0,
      agreementReadModal: false,
      applyAgreementData: {},
    };
  },
  computed: {
    //  "state": "3",  // 项目状态  3-未开始 4-报名中 5-报名截止 6-竞价中 7-流拍 8-项目中止 9-已成交
    ...mapGetters([
      "siteInfo",
      "isLogin",
      "cmsNoticeNode",
      "userinfo",
      "priceUnitKey",
      "stateAllKey",
    ]),
    // 价格描述
    auctionTime() {
      return function (time) {
        return time.replace(/:\d{2}$/, "");
      };
    },
    // 价格描述
    priceDesc() {
      return function (state) {
        let text = "";
        switch (state) {
          case 9:
            text = "成交价：";
            break;
          default:
            text = "当前价：";
            break;
        }
        return text;
      };
    },
    // 状态
    stateDesc() {
      return this.stateAllKey[this.itemDetail.project.tradeMode][
        this.itemDetail.state
      ];
    },
    // 状态颜色
    stateColor() {
      return function (state) {
        switch (state) {
          case 3:
          case 4:
            return "bc_22D179";
          case 6:
            return "bc_EF3946";
          default:
            return "bc_808080";
        }
      };
    },
    // 交易模式文本
    tradeModeText() {
      return TradeModeText[this.itemDetail.project.tradeMode];
    },
    // 是否报名中
    isApplying() {
      return this.itemDetail.state === 4;
    },
    // 是否未开始
    isAdvancing() {
      return this.itemDetail.state === 3;
    },
    // 是否终止
    isState8() {
      return this.itemDetail.state === 8;
    },
    // 是否截止
    isState5() {
      return this.itemDetail.state === 5;
    },
    // 项目信息
    projectInfo() {
      return this.itemDetail.project;
    },
    // 是否正向
    isPositive() {
      return this.itemDetail.direction === "positive";
    },
    // 是否反向
    isReverse() {
      return this.itemDetail.direction === "reverse";
    },
    // 是否首次出价
    isFirstBid() {
      return this.itemDetail?.biddings?.length === 0; // 判断出价记录
    },
    // 是否阶梯竞价
    isLadderAuction() {
      // 0：表示阶梯
      return this.itemDetail.auctionMode === 0;
    },
    // 是否显示竞价幅度按钮
    showBidMoneyRange() {
      return (
        [3, 4, 5, 6].includes(this.itemDetail.state) ||
        (this.itemDetail.state === 5 && this.isLogin)
      );
    },
    // 显示提醒登录按钮
    showRemindLogin() {
      let { isApply } = this.itemDetail;
      return (
        (isApply || [4, 5, 6].includes(this.itemDetail.state)) &&
        !this.isLogin &&
        this.isDeposit
      );
    },
    // 不显示提醒按钮
    noShowRemindLogin() {
      return [3].includes(this.itemDetail.state);
    },
    // 是否显示缴纳保证金
    isShowMriginApply() {
      let { state } = this.itemDetail;
      return state === 3 || (this.isApplying && !this.allowApply);
    },
    // 是否需要缴纳保证金
    isDeposit() {
      return this.itemDetail.deposit === 1;
    },
    // 是否显示出价区块
    showBidBlock() {
      let { state, isApply } = this.itemDetail;
      return [4, 5, 6].includes(state) || (this.isLogin && isApply);
    },
    // 是否显示出价按钮
    showBidBtn() {
      let { state } = this.itemDetail;
      return [5, 6].includes(state) || (this.isApplying && this.allowApply);
    },
    // 是否显示出价提醒
    showBidRemindBtn() {
      let { state } = this.itemDetail;
      return [6].includes(state);
    },
    // 竞价标识
    BidFlag() {
      let { state } = this.itemDetail;
      return [6].includes(state) || (this.isApplying && this.allowApply);
    },
    // 是否禁止出价
    disBidMoney() {
      return function (state) {
        return [3, 4, 5].includes(state) || this.checkBidCount;
      };
    },
    // 是否显示未报名文本提示
    showNotApplyText() {
      let { state, isApply } = this.itemDetail;
      return !isApply && state === 6 && this.isLogin;
    },
    // 验证出价次数是否超出指定次数（true表示超出）
    checkBidCount() {
      return (
        this.itemDetail.bidCount === 1 &&
        this.itemDetail.userBidCount >= this.itemDetail.bidCount
      );
    },
    // 允许幅度递减
    allowReduceRange() {
      let money = new Decimal(this.publicForm.floorPrice || 0);
      if (this.isPositive) {
        if (
          money.equals(Decimal(this.itemDetail.currentPrice)) ||
          money.lessThanOrEqualTo(0)
        ) {
          return false;
        }
      }
      if (this.disBidMoney(this.itemDetail.state)) return false;
      return true;
    },
    // 允许幅度递增
    allowAddRange() {
      let money = new Decimal(this.publicForm.floorPrice || 0);
      if (this.isReverse) {
        if (!this.validMoneyRange) {
          this.$set(
            this.publicForm,
            "floorPrice",
            this.itemDetail.currentPrice
          );
          return false;
        }
        if (
          money.equals(Decimal(this.itemDetail.currentPrice)) ||
          money.lessThanOrEqualTo(0)
        ) {
          return false;
        }
      }
      if (this.disBidMoney(this.itemDetail.state)) return false;
      return true;
    },
    // 有效出价幅度（如果阶梯竞价，检验出价金额与当前价相差是否是竞价幅度的整数倍）
    validMoneyRange() {
      if (this.isLadderAuction) {
        let auctionRange = new Decimal(this.itemDetail.auctionRange || 1);

        let diff = new Decimal(
          Decimal.sub(
            Decimal(this.publicForm.floorPrice).toNumber(),
            Decimal(this.itemDetail.currentPrice).toNumber()
          ).toFixed(2, Decimal.ROUND_DOWN)
        );

        if (diff.isZero()) return true;

        diff = Decimal.abs(diff); // 取绝对值（考虑正向和反向）
        // 如果差值本身就小于竞价幅度
        if (diff.lessThan(auctionRange)) {
          return false;
        }
        return diff.mod(auctionRange).isZero();
      }
      return true;
    },
    // 出价金额是否已经是最小值
    isMinBidMoney() {
      let floorPrice = new Decimal(this.publicForm.floorPrice || 0);
      let auctionRange = new Decimal(this.itemDetail.auctionRange || 1);
      // （只有是反向，是竞价幅度的整数倍，是小于竞价幅度，是大于0才会有这种情况）
      if (
        this.isReverse &&
        this.validMoneyRange &&
        floorPrice.lessThan(auctionRange) &&
        floorPrice.greaterThan(0)
      ) {
        if (floorPrice.sub(auctionRange).lessThanOrEqualTo(auctionRange)) {
          return true;
        }
      }
      return false;
    },
    //距文本描述
    spaceDes() {
      return function (state) {
        switch (state) {
          case 3:
            return "距开始";
          case 4:
            return "距截止";
          case 5:
            return "距竞价";
          case 6:
            return "距结束";
          case 7:
          case 8:
          case 9:
          case 10:
            return "结束时间";
        }
      };
    },
    //格式化时间
    formatDate: function () {
      return function (date, fmt) {
        if (!date) return "";
        return formatDate(new Date(date), fmt);
      };
    },
    tranTimeFormat() {
      return function (dateStr) {
        if (!dateStr) return "";
        return dateStr.replace(/-/g, "/");
      };
    },
    //格式化金额（小数点）
    formatMoney: function () {
      return function (num) {
        return Number(num).toLocaleString();
      };
    },
    //项目是否已结束
    isEnd() {
      return [7, 8, 9, 10].includes(this.itemDetail.state);
    },
    amountTran: function () {
      return function (num) {
        return amountTran(num);
      };
    },
    numTranFloat: function () {
      return function (num) {
        return numTranFloat(num);
      };
    },
    // 天
    d() {
      return Math.floor(this.diffTime / (1000 * 60 * 60) / 24);
    },
    // 时
    h() {
      return Math.floor((this.diffTime / (1000 * 60 * 60)) % 24);
    },
    // 分
    m() {
      return Math.floor((this.diffTime / (1000 * 60)) % 60);
    },
    // 秒
    s() {
      return Math.floor((this.diffTime / 1000) % 60);
    },
    // 是否显示倒计时
    isShowCountDown() {
      return [3, 4, 5, 6].includes(this.itemDetail.state);
    },
    // 通知公告
    tnoticeNode() {
      return this.cmsNoticeNode.children.find((i) => i.code === "tnotice");
    },
    // 成交公告
    cnoticeNode() {
      return this.cmsNoticeNode.children.find((i) => i.code === "resultnotice");
    },
  },
  watch: {
    diffTime(n) {
      if (n <= 0) {
        this.diffTime = 0;
        clearInterval(this.countDownTimer);
      }
    },
    "publicForm.floorPrice": {
      handler(v) {
        if (!isEmtry(v)) {
          this.inputPrice = v.valueOf();
        }
      },
      immediate: true,
    },
    "itemDetail.state": function (n) {
      //如果竞拍状态是报名中并且已登录，则校验该用户是否可报名
      if (this.isApplying && this.isLogin) {
        this.checkApplyed(this.itemDetail.projectNo);
      }
    },
    isEnd: {
      async handler(n) {
        if (n) {
          await this.initNoticeNode();
          this.checkNotice(this.itemDetail.projectNo);
          clearInterval(this.countDownTimer);
          clearInterval(this.pollIntervalTimer);
        } else {
          this.initAuctionWs();
          if (this.isLogin) {
            this.initApplyWs();
          }
        }
      },
      immediate: true,
    },
  },
  async created() {
    this.initDetailData(this.itemDetail);
    if (this.isShowCountDown) {
      this.computedDiffTime();
      this.startCountDown();
      this.startPollInterval();
      this.pageVisibilitychange();
    }
    // 检查是否可报名
    if (this.isApplying && this.isLogin) {
      this.checkApplyed(this.itemDetail.projectNo);
    }
    // this.getApplyAgreement()
  },
  mounted() {
    window.addEventListener("visibilitychange", this.handlePage);
    this.$refs?.publicForm?.validate(); // 首次先校验一次
  },
  methods: {
    ...mapActions({
      initNoticeNode: "cache/initNoticeNode",
    }),

    //初始详情数据
    initDetailData(data) {
      this.publicForm.projectNo = this.itemDetail.projectNo;
      this.isPositive && this.initPositiveMoney(data);
      this.isReverse && this.initReverseMoney(data);
    },
    // 开启倒计时
    startCountDown() {
      clearInterval(this.countDownTimer);
      this.countDownTimer = setInterval(() => {
        if (this.diffTime < 0) {
          clearInterval(this.countDownTimer);
        }
        this.diffTime -= 1000;
      }, 1000);
    },
    // 计算时差
    computedDiffTime(countdownTime) {
      this.diffTime = countdownTime || this.itemDetail.countdownTime;
    },
    // 校准倒计时
    async checkCountDown() {
      let { data } = await project_beat_time({
        projectNo: this.itemDetail.projectNo,
        uid: uuid(13),
      });
      this.diffTime = data.countdownTime;
      this.startCountDown();
      this.startPollInterval();
    },
    // 开启轮询
    startPollInterval() {
      clearInterval(this.pollIntervalTimer);
      this.pollIntervalTimer = setInterval(async () => {
        this.checkCountDown();
      }, this.pollInterval);
    },
    // 页面可见 change
    pageVisibilitychange() {
      window.addEventListener("visibilitychange", this.handlePage);
    },
    // 处理页面显示
    handlePage() {
      if (!document.hidden) {
        // 状态判断：显示（切换到当前页面）
        if (this.isShowCountDown) {
          this.checkCountDown();
        }
      }
    },

    // 初始正向金额
    initPositiveMoney(data) {
      //如果是优先权人且最后一次出价为非优先权人出的价，则可出相同的价格
      if (
        this.itemDetail.isPriority &&
        this.itemDetail.biddings[0]?.priority === 0
      ) {
        this.$set(
          this.publicForm,
          "floorPrice",
          Decimal(data.currentPrice || 0).toFixed(2, Decimal.ROUND_DOWN)
        );
        //如果没人出价，则出价数值默认是底价
      } else if (!this.isFirstBid) {
        this.$set(
          this.publicForm,
          "floorPrice",
          Decimal(data.currentPrice)
            .add(Decimal(data.auctionRange) || 1)
            .toFixed(2, Decimal.ROUND_DOWN)
        );
      } else {
        this.$set(
          this.publicForm,
          "floorPrice",
          Decimal(data.currentPrice || 0).toFixed(2, Decimal.ROUND_DOWN)
        );
      }
    },
    // 初始反向金额
    initReverseMoney(data) {
      if (
        this.itemDetail.biddings[0]?.priority === 0 &&
        this.itemDetail.isPriority
      ) {
        this.$set(
          this.publicForm,
          "floorPrice",
          Decimal(data.currentPrice || 0).toFixed(2, Decimal.ROUND_DOWN)
        );
        //如果没人出价，则出价数值默认是底价
      } else if (
        !this.isFirstBid &&
        Decimal(data.currentPrice).sub(data.auctionRange).greaterThan(0)
      ) {
        this.$set(
          this.publicForm,
          "floorPrice",
          Decimal(data.currentPrice)
            .sub(Decimal(data.auctionRange) || 1)
            .toFixed(2, Decimal.ROUND_DOWN)
        );
      } else {
        this.$set(
          this.publicForm,
          "floorPrice",
          Decimal(data.currentPrice || 0).toFixed(2, Decimal.ROUND_DOWN)
        );
      }
    },
    // 输入保留小数点后两位
    onTofixedInput(e, form, prop) {
      form[prop] = /^\./g.test(e)
        ? "0" + e.match(/^\d*(\.?\d{0,2})/g)[0]
        : e.match(/^\d*(\.?\d{0,2})/g)[0];
      this.inputPrice = form[prop];
      console.log("onTofixedInput", e, form[prop], this.inputPrice);
    },

    //初始化 用户socket连接
    initApplyWs() {
      this.userWs = new MySocket({
        url: process.env.VUE_APP_PTP_API,
      });

      this.userWs.doConnect().then(() => {
        this.userWs.doSubscribe(
          `/user/${this.userinfo.uuid}/auction/` + this.itemDetail.projectNo,
          (msg) => {
            //订阅列表的每条消息
            this.applyWsRes = JSON.parse(msg.body);
            this.onHandleUserWsEvent(this.applyWsRes.event);
          }
        );
      });

      window.addEventListener("online", this.handleWsOnline);
      window.addEventListener("offline", this.handleWsOffline);
    },
    // 处理用户信息socket响应的事件
    onHandleUserWsEvent(eventKey) {
      switch (eventKey) {
        case "apply":
          this.handleWsApply();
          break;
        case "bidCount":
          this.handleWsBidCount();
          break;
      }
    },
    // 处理是否报名成功
    handleWsApply() {
      let { apply } = this.applyWsRes;
      this.allowApply = apply;
      this.itemDetail.isApply = apply;
      console.log(
        "this.itemDetail.auctionBidUser",
        this.itemDetail.auctionBidUser
      );
      this.$set(this.itemDetail, "auctionBidUser", {
        auctionNo: this.applyWsRes.auctionNo,
        username: this.applyWsRes.username,
      });
    },
    // 处理出价次数
    handleWsBidCount() {
      let { bidCount } = this.applyWsRes;
      this.itemDetail.userBidCount = bidCount;
    },

    //初始化 竞拍socket连接（项目）
    initAuctionWs() {
      this.auctionWs = new MySocket({
        url: process.env.VUE_APP_WS_API,
      });

      this.auctionWs.doConnect().then(() => {
        this.auctionWs.doSubscribe(
          "/topic/auction/" + this.itemDetail.projectNo,
          (msg) => {
            //订阅列表的每条消息
            this.socketDataRes = JSON.parse(msg.body);
            console.log("socketDataRes", this.socketDataRes);
            this.onHandleAuctionWsEvent(this.socketDataRes.event);
            console.log("this.socketDataRes.event", this.socketDataRes.event);
          }
        );
      });

      window.addEventListener("online", this.handleWsOnline);
      window.addEventListener("offline", this.handleWsOffline);
    },
    // 处理竞拍socket响应的事件
    onHandleAuctionWsEvent(eventKey) {
      switch (eventKey) {
        case "stateChange":
          this.handleStateChange();
          break;
        case "delayed":
          this.handleDelayed();
          break;
        case "bid":
          this.handleBid();
          break;
        case "end":
          this.handleEnd();
          break;
      }
    },
    //处理-项目状态
    handleStateChange() {
      console.log("状态变更");
      this.itemDetail.auctionState = Number(this.socketDataRes.auctionState);
      this.itemDetail.auctionStateDesc = this.socketDataRes.stateDesc;
      this.itemDetail.sysDate = this.socketDataRes.sysDate;
      this.itemDetail.state = this.socketDataRes.state - 0;
      this.computedDiffTime(this.socketDataRes.countdownTime);
      this.startCountDown();
      // 项目中止状态检查（通知公告）
      if ([8].includes(this.itemDetail.state)) {
        new Ctv(this.checkNoticeIdKeys.informId, {
          success: (v) => {},
          fail: (first, instance) => {
            this.checkNotice(this.itemDetail.projectNo);
            if (!first) {
              instance.handle(this.checkNoticeIdKeys.informId);
            }
          },
        });
      }
      //项目结束关闭倒计时
      if (this.isEnd) {
        clearInterval(this.countDownTimer);
        clearInterval(this.pollIntervalTimer);
      }
    },
    //处理-项目延时
    handleDelayed() {
      this.computedDiffTime(this.socketDataRes.countdownTime);
      this.startCountDown();
    },
    //处理-出价
    handleBid() {
      let floorPrice = Decimal(this.publicForm.floorPrice).toFixed(
        2,
        Decimal.ROUND_DOWN
      );
      this.itemDetail.currentPrice = Decimal(this.socketDataRes.currentPrice);
      let auctionRange = Decimal(this.itemDetail.auctionRange || 1);
      let currentPrice = Decimal(this.socketDataRes.currentPrice); // 每次出完价，重置当前价
      this.itemDetail.biddings = this.socketDataRes.biddings;
      // 正向
      if (
        this.isPositive &&
        this.itemDetail.isPriority &&
        this.itemDetail.biddings[0]?.priority === 0
      ) {
        floorPrice = currentPrice;
      } else if (this.isPositive) {
        floorPrice = Decimal.add(currentPrice, auctionRange); //如果竞价幅度小于0，则默认加1元
      }
      // 反向
      if (this.isReverse) {
        if (
          this.itemDetail.isPriority &&
          this.itemDetail.biddings[0]?.priority === 0
        ) {
          this.$set(
            this.publicForm,
            "floorPrice",
            currentPrice.toFixed(2, Decimal.ROUND_DOWN)
          );
          this.$refs.publicForm.validate();
        } else {
          floorPrice = currentPrice.sub(auctionRange); //如果竞价幅度小于0，则默认减1元
        }
      }
      this.$set(
        this.publicForm,
        "floorPrice",
        floorPrice.toFixed(2, Decimal.ROUND_DOWN)
      );
    },
    //处理-项目结束
    handleEnd() {
      this.itemDetail.state = this.socketDataRes.state - 0;
      this.itemDetail.auctionState = Number(this.socketDataRes.auctionState);
      this.itemDetail.auctionStateDesc = this.socketDataRes.stateDesc;
      this.itemDetail.stateEndTime = this.socketDataRes.endTime;
      this.itemDetail.currentPrice =
        this.socketDataRes.price || this.itemDetail.currentPrice; //如果结束状态是中止，则取原来的价格
      this.itemDetail.remark = this.socketDataRes.remark;

      let noticeMap = new Map();
      noticeMap.set(9, "makeId");
      noticeMap.set(8, "informId");
      // 项目成交状态检查（成交公告）
      if (noticeMap.has(this.itemDetail.state)) {
        new Ctv(this.checkNoticeIdKeys[noticeMap.get(this.itemDetail.state)], {
          success: (v) => {},
          fail: (first, instance) => {
            this.checkNotice(this.itemDetail.projectNo);
            if (!first) {
              instance.handle(
                this.checkNoticeIdKeys[noticeMap.get(this.itemDetail.state)]
              );
            }
          },
        });
      }
      //项目结束关闭倒计时
      if (this.isEnd) {
        clearInterval(this.countDownTimer);
        clearInterval(this.pollIntervalTimer);
      }
    },
    // 处理网络在线
    handleWsOnline(e) {
      this.$emit("onRefresh");
      this.initAuctionWs();
      if (this.isLogin) {
        this.initApplyWs();
      }
      if (!this.isEnd) {
        this.checkCountDown();
      }
      this.$notify({
        type: "success",
        title: "提示",
        message: "连接成功。",
        duration: 5000,
      });
    },
    handleApplyResult() {},
    // 处理网络离线
    handleWsOffline(e) {
      this.auctionWs?.stompClient?.disconnect();
      this.userWs?.stompClient?.disconnect();
      this.$notify({
        type: "warning",
        title: "提示",
        message: "网络异常，正在尝试重新连接...",
        duration: 5000,
      });
    },
    // 处理页面显示隐藏
    handlePage() {
      if (!document.hidden) {
        if (!this.isEnd) {
          this.checkCountDown();
        }
      }
    },
    // 提醒登录 click
    onLoginClick() {
      this.$router.push({
        path: "/login",
        query: {
          returnUrl: this.$route.fullPath,
        },
      });
    },
    // 出价 click
    onAutionBidClick() {
      if (!this.publicForm.floorPrice || !this.allowBidMoney) return;
      confirmCallBack.call(this, {
        content: `您提交的竞价为 ￥ ${this.publicForm.floorPrice}元，是否提交 ？`,
        title: "提示",
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        success: async () => {
          let res = await auction_bid({
            bidMoney: this.publicForm.floorPrice,
            projectNo: this.publicForm.projectNo,
          });
          if (res.code === 200) {
            this.$notify({
              type: "success",
              message: "出价成功！",
            });
          }
        },
        cancel: () => {},
      });
    },
    //缴纳保证金报名 click
    onMriginApplyClick() {
      if (this.isAdvancing) return;
      //未登录，则前往登录
      if (!this.isLogin) {
        this.$router.push({
          path: "/login",
          query: {
            returnUrl: this.$route.fullPath,
            margin: this.itemDetail.margin,
            projectNo: this.itemDetail.projectNo,
          },
        });
        return;
      }
      // 弹出报名协议
      this.goApply();
      // this.agreementReadModal = true
    },
    // 跳转报名页
    goApply() {
      this.$router.push({
        name: "tradeApply",
        query: {
          projectNo: this.itemDetail.projectNo,
          margin: this.itemDetail.margin,
          tradeKind: this.itemDetail.project.tradeKind,
          tradeMode: this.itemDetail.project.tradeMode,
        },
      });
    },
    // 增加竞价幅度 click
    onAddAuctionRange() {
      if (!this.allowAddRange) return;
      if (isEmtry(this.publicForm.floorPrice)) {
        this.publicForm.floorPrice = 0;
      }
      //如果出价校验不通过，则等于当前价再加一次幅度
      if (!this.allowBidMoney) {
        this.publicForm.floorPrice = Decimal(this.itemDetail.currentPrice)
          .add(Decimal(this.itemDetail.auctionRange || 1))
          .toFixed(2, Decimal.ROUND_DOWN);
        return;
      }
      // 正常加价 （保留到小数点后两位）
      this.publicForm.floorPrice = Decimal(this.publicForm.floorPrice)
        .add(Decimal(this.itemDetail.auctionRange || 1))
        .toFixed(2, Decimal.ROUND_DOWN);
    },
    // 减低竞价幅度 click
    onReduceAuctionRange() {
      if (!this.allowReduceRange || this.isMinBidMoney) return;
      //当计算的金额小于0时，则重置到0
      if (Decimal(this.publicForm.floorPrice).lessThanOrEqualTo(0)) {
        this.publicForm.floorPrice = 0;
      }
      //如果出价校验不通过，则等于当前价再减一次幅度
      if (!this.allowBidMoney) {
        this.publicForm.floorPrice = Decimal(this.itemDetail.currentPrice)
          .sub(Decimal(this.itemDetail.auctionRange || 1))
          .toFixed(2, Decimal.ROUND_DOWN);
        return;
      }
      // 正常减价（保留到小数点后两位）
      if (this.allowBidMoney) {
        this.publicForm.floorPrice = Decimal(this.publicForm.floorPrice)
          .sub(Decimal(this.itemDetail.auctionRange || 1))
          .toFixed(2, Decimal.ROUND_DOWN);
      }
    },
    //检查是否已报名（未知是否审批通过） api
    async checkApplyed(projectNo) {
      let { data } = await auction_applyed({ projectNo });
      this.allowApply = data; //true：表示已报名；false：未报名
    },
    //检查该项目包含的公告文件
    async checkNotice(projectNo) {
      let { data } = await auction_checkNotice({ projectNo });
      this.checkNoticeIdKeys = data;
    },
    //获取项目公告的文件数据（成交，鉴证，通知）
    async goCmsNode(cmsNode, articleId) {
      this.$router.push(`${cmsNode.infoModel.route}/${articleId}`);
    },
    // 任一表单项被校验后触发（校验是否可出价）
    onValidatePublicForm(prop, valid, err) {
      this.allowBidMoney = valid;
    },
    // 获取报名协议
    async getApplyAgreement() {
      let { data } = await cms_code_article_info({
        code: "apply_agreement",
      });
      this.applyAgreementData = data;
    },
    // 取消报名协议
    onCancalAgreement() {
      this.agreementReadModal = false;
    },
    // 同意报名协议
    onConfirmAgreement() {
      this.goApply();
    },
    convertPriceToInt(normalizedPrice) {
      // 判断浮点数是否为整数或者小数点后面都是0
      let floatValue = parseFloat(normalizedPrice);
      if (
        Number.isInteger(floatValue) ||
        floatValue.toFixed(2).endsWith("00")
      ) {
        return Math.floor(floatValue) + ""; // 如果是整数或小数点后面都是0，则向下取整
      } else {
        return floatValue + ""; // 否则保持原浮点数
      }
    },
  },
  destroyed() {
    clearInterval(this.countDownTimer); //清除项目详情倒计时
    clearInterval(this.pollIntervalTimer);
    this.auctionWs?.stompClient?.disconnect(); //关闭socket连接
    this.userWs?.stompClient?.disconnect(); //关闭socket连接
    window.removeEventListener("online", this.handleWsOnline);
    window.removeEventListener("offline", this.handleWsOffline);
    window.removeEventListener("visibilitychange", this.handlePage);
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 440px;
  min-height: 30px;
  background-color: #0283cc;
  color: white;
}
.text-overflow-example {
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏溢出的内容 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  padding-left: 20px;
  text-align: center;
  line-height: 20px; /* 调整行高以适应内容 */
}
.pro_main_w {
  overflow: hidden;
  position: relative;
  width: 440px;
  margin: 0 10px;
  border: 1px solid #e6e6e6;
  .pro-state {
    position: absolute;
    top: 0;
    right: 0;
    width: 100px;
    height: 100px;
    line-height: 170px;
    transform: translate(50px, -50px) rotateZ(45deg);
    text-align: center;
    color: #fff;
    font-size: 12px;
  }
}
.detail_main_info {
  // height: 316px;
  .state_time_desc {
    // margin: 0 7px 0 0;
  }
  .price_w {
    margin: 12px 0 0 0;
    & > span {
      &:first-child {
        margin: 0 18px 0 0;
      }
    }
  }
  .notice_btn,
  .verification_btn {
    width: 122px;
    box-sizing: border-box;
    padding: 15px 0 13px 0;
    text-align: center;
  }
  .notice_btn {
    &:hover,
    &:focus {
      background-color: rgba($color: #0983cc, $alpha: 0.9);
      color: #fff;
    }
    &.is-disabled {
      background-color: rgba($color: #0983cc, $alpha: 0.6);
      color: #fff;
    }
  }
  .verification_btn {
    &:hover,
    &:focus {
      color: #1a1a1a;
      background-color: rgba($color: #fff, $alpha: 0.9);
    }
    &.is-disabled {
      color: #c0c4cc;
    }
    margin: 0 0 0 13px;
  }
  .state_end_desc {
    margin: 0 0 12px 0;
    & > img {
      margin: 0 14px 0 0;
    }
  }
  .main_block_2 {
    height: 139px;
    .bid_text {
      margin: 0 20px;
      line-height: 36px;
    }
  }
  .main_block_22 {
    height: 170px;
    .bid_text {
      margin: 0 20px;
      line-height: 36px;
    }
  }
  .main_block_222 {
    height: 129px;
    .bid_text {
      margin: 0 20px;
      line-height: 36px;
    }
  }
  .main_block_2222 {
    height: 145px;
    .bid_text {
      margin: 0 20px;
      line-height: 36px;
    }
  }
  .main_block_1 {
    position: relative;
    padding: 8px 0 0 8px;
    .cell_label {
      display: inline-block;
      min-width: 60px;
      white-space: nowrap;
      text-align: right;
    }
    .time_i {
      margin: 0 4px 0 0;
    }
    .time_num {
      margin: 0 5px;
    }
    .delay-count {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 12px;
      background-color: #0983cc;
      color: #fff;
      padding: 4px 10px;
    }
  }
  .main_block_11 {
    position: relative;
    padding: 20px 0 0 10px;
    .cell_label {
      display: inline-block;
      min-width: 60px;
      white-space: nowrap;
      text-align: right;
    }
    .time_i {
      margin: 0 4px 0 0;
    }
    .time_num {
      margin: 0 4px;
    }
    .delay-count {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 12px;
      background-color: #0983cc;
      color: #fff;
      padding: 4px 10px;
    }
  }
  .main_block_3 {
    .cell_i {
      height: 32px;
      line-height: 32px;
      flex: 1;
      text-align: center;
      border-bottom: 1px solid #e6e6e6;
      &:nth-child(2) {
        border-right: 1px solid #e6e6e6;
        border-left: 1px solid #e6e6e6;
      }
    }
    .cell_i02 {
      height: 25px;
      line-height: 25px;
      flex: 1;
      text-align: center;
      border-bottom: 1px solid #e6e6e6;
      &:nth-child(2) {
        border-right: 1px solid #e6e6e6;
        border-left: 1px solid #e6e6e6;
      }
    }
  }
}

.cell_row {
  margin: 12px 0 10px 0;
  align-items: baseline;
}

.price_input {
  width: auto;
}
::v-deep .price_input .el-input__inner {
  width: 242px;
  height: 38px;
  box-sizing: border-box;
}
.range_w {
  margin: 0 0 0 4px;
  & > .add_range,
  .Reduce_range {
    width: 34px;
    height: 15px;
    cursor: pointer;
  }
  & > .add_range {
    background: #0983cc url("~@/assets/images/add_range.png") center center
      no-repeat;
  }
  & > .Reduce_range {
    background: #0983cc url("~@/assets/images/reduce_range.png") center center
      no-repeat;
  }
}

.pay_margin {
  width: 212px;
  padding: 6px 34px;
  cursor: not-allowed;
}
.allow_buy {
  background-color: #0983cc;
  cursor: pointer !important;
}

.bid_btn {
  width: 280px;
  height: 40px;
  font-size: 12px;
  box-sizing: border-box;
  border-radius: 0;
  color: #fff !important;
  position: relative;
  top: -14px;
  margin-top: 16px;
  &:hover,
  &:focus {
    background-color: rgba($color: #0983cc, $alpha: 0.9);
  }
  &.is-disabled {
    color: #fff !important;
    background-color: #999 !important;
  }
}
.cannot_bid_tip {
  position: relative;
  top: -22px;
}
.paid_login {
  margin: 3px 0 0 0;
  padding: 5px 10px 5px 7px;
  background-color: #fefee4;
  color: rgb(136, 135, 135);
}
.paid_login01 {
  margin: 3px 0 0 0;
  padding: 5px 10px 5px 7px;
  background-color: #fefee4;
  color: rgb(136, 135, 135);
}
.paid_login02 {
  margin: 3px 0 0 0;
  padding: 5px 0px 5px 2px;
  background-color: #fefee4;
  color: rgb(136, 135, 135);
}
.paid_login03 {
  position: relative;
  width: 440px;
  height: 20px;
  padding: 0px 0px 0px 10px;
  background-color: #ffffff;
  color: #de6c2d;
}
.login_btn {
  margin: 0 0 0 5px;
  color: #0983cc;
  text-decoration: underline;
}
.main_block_4 {
  padding: 0 20px;
  .cell_row {
    margin: 10px 0;
  }
}
.location {
  position: relative;
  top: 4px;
}
.location_top {
  position: relative;
  top: -9px;
}
.state5 {
  position: relative;
  top: -12px;
}
</style>
